import { default as http } from "../rest/http";

export interface GlobalSearchParams {
  page: number;
  per_page: number;
  searchText: string;
  role?: string;
  status?: string;
  organizationId?: string;
}

// Mock data for search results
const mockSearchResults = {
  page: 1,
  per_page: 10,
  total_pages: 2,
  total_items: 14,
  users: [
    {
      id: "7c71906b-c1be-452c-936f-90b7419d0178",
      first: "Jane",
      last: "Cooper",
      email: "jc@example.com",
      role: "FINLEY_USER",
      mobilePhone: null,
      goal: null,
      emailVerified: false,
      onboardingSate: null,
      externalUniqueId: "9223fe87-2adf-49f2-991f-2184fae3ffa6",
      createdAt: "2024-09-23T09:01:26.391763+00:00",
      organization: { id: 1, name: "Test Sub Org1" },
      isActive: true,
      invitationSentAt: "2024-09-20T09:01:26.391763+00:00",
      deactivatedAt: null,
    },
    {
      id: "8d82a17c-d2cf-563d-a47g-91c8520e1289",
      first: "Jane",
      last: "Cooper2",
      email: "jc2@example.com",
      role: "SUPER_ADMIN",
      mobilePhone: null,
      goal: null,
      emailVerified: true,
      onboardingSate: "ONBOARDING_COMPLETED",
      externalUniqueId: "a334gf98-3beg-50g3-aa2g-3295gbg4ggb7",
      createdAt: "2024-08-15T09:01:26.391763+00:00",
      organization: { id: 2, name: "Test Sub Org2" },
      isActive: true,
      invitationSentAt: "2024-08-10T09:01:26.391763+00:00",
      deactivatedAt: null,
    },
    {
      id: "9e93b28d-e3dg-674e-b58h-02d9631f2390",
      first: "Jane",
      last: "Cooper3",
      email: "jc3@example.com",
      role: "FINANCIAL_COACH",
      mobilePhone: null,
      goal: null,
      emailVerified: false,
      onboardingSate: null,
      externalUniqueId: "b445hg09-4cfh-61h4-bb3h-4306hch5hhc8",
      createdAt: "2024-07-10T09:01:26.391763+00:00",
      organization: { id: 3, name: "Test Sub Org3" },
      isActive: false,
      invitationSentAt: null,
      deactivatedAt: "2025-01-15T09:01:26.391763+00:00",
    },
    {
      id: "af04c39e-f4eh-785f-c69i-13ea742g3401",
      first: "Robert",
      last: "Johnson",
      email: "rj@example.com",
      role: "FINLEY_USER",
      mobilePhone: null,
      goal: null,
      emailVerified: true,
      onboardingSate: "SIGNED_UP",
      externalUniqueId: "c556ij10-5dgi-72i5-cc4i-5417idi6iid9",
      createdAt: "2024-10-05T09:01:26.391763+00:00",
      organization: { id: 1, name: "Test Sub Org1" },
      isActive: true,
      invitationSentAt: "2024-10-01T09:01:26.391763+00:00",
      deactivatedAt: null,
    },
  ],
  organizations: [
    {
      id: 36,
      name: "Rowe - Hane O'Hara - Terry",
      displayName: "Rowe - Hane O'Hara - Terry",
      contactName: "Rowe - Hane O'Hara - Terry",
      contactEmail: "rowterry@gl.com",
      parentOrgId: null,
      is_active: true,
      created_at: "2024-09-25T04:59:19.848553+00:00",
      updated_at: "2024-09-25T04:59:19.848557+00:00",
      activeUsers: 3,
      activeSubOrgs: 5,
      totalActiveOrganizations: null,
      totalActiveUsers: null,
      subOrgs: [
        { orgId: "3", name: "Job Test Org", displayName: "Job Test Org" },
        { orgId: "4", name: "Job Test Org 2", displayName: "Job Test Org 2" },
      ],
    },
    {
      id: 37,
      name: "Rowe - Hane O'Hara - Terry 1",
      displayName: "Rowe - Hane O'Hara - Terry 1",
      contactName: "Rowe - Hane O'Hara - Terry",
      contactEmail: "rowterry1@gl.com",
      parentOrgId: null,
      is_active: true,
      created_at: "2024-09-25T04:59:19.848553+00:00",
      updated_at: "2024-09-25T04:59:19.848557+00:00",
      activeUsers: 0,
      activeSubOrgs: 0,
      totalActiveOrganizations: null,
      totalActiveUsers: null,
      subOrgs: [],
    },
    {
      id: 38,
      name: "Rowe - Hane O'Hara - Terry 2",
      displayName: "Rowe - Hane O'Hara - Terry 2",
      contactName: "Rowe - Hane O'Hara - Terry",
      contactEmail: "rowterry2@gl.com",
      parentOrgId: null,
      is_active: true,
      created_at: "2024-09-25T04:59:19.848553+00:00",
      updated_at: "2024-09-25T04:59:19.848557+00:00",
      activeUsers: 7,
      activeSubOrgs: 2,
      totalActiveOrganizations: null,
      totalActiveUsers: null,
      subOrgs: [
        { orgId: "3", name: "Job Test Org", displayName: "Job Test Org" },
        { orgId: "4", name: "Job Test Org 2", displayName: "Job Test Org 2" },
      ],
    },
  ],
};

// Mock data for filter dropdowns
const mockFilterOptions = {
  roles: [
    { role: "ALL", displayName: "All" },
    { role: "SUPER_ADMIN", displayName: "Super Admin" },
    { role: "ORG_ADMIN", displayName: "Organization Admin" },
    { role: "FINLEY_USER", displayName: "Finley User" },
    { role: "FINANCIAL_COACH", displayName: "Coach" },
  ],
  statuses: [
    { status: "ALL", displayName: "All" },
    { status: "ACTIVE", displayName: "Active" },
    { status: "INVITED", displayName: "Invited" },
    { status: "DEACTIVATED", displayName: "Deactivated" },
    { status: "SIGNED_UP", displayName: "Signed Up" },
  ],
  organizations: [
    {
      id: "1",
      name: "Beta Networks",
      displayName: "Beta Networks",
      subOrgs: [
        { orgId: "3", name: "Job Test Org", displayName: "Job Test Org" },
        { orgId: "4", name: "Job Test Org 2", displayName: "Job Test Org 2" },
      ],
    },
  ],
};

export const fetchGlobalSearchResults = async (params: GlobalSearchParams) => {
  try {
    // TODO: Replace mock with real API call when ready
    // const queryParams = new URLSearchParams({
    //   page: params.page.toString(),
    //   per_page: params.per_page.toString(),
    //   searchText: params.searchText,
    //   ...(params.role && params.role !== 'ALL' && { role: params.role }),
    //   ...(params.status && params.status !== 'ALL' && { status: params.status }),
    //   ...(params.organizationId && { OrganizationId: params.organizationId }),
    // });
    // const url = `/master-data/global-search?${queryParams.toString()}`;
    // const response = await http.get(url);
    // return response;

    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));
    return { ...mockSearchResults, page: params.page, per_page: params.per_page };
  } catch (error) {
    console.error("Error fetching global search results:", error);
    throw error;
  }
};

export const fetchSearchFilterOptions = async () => {
  try {
    // TODO: Replace mock with real API call when ready
    // const response = await http.get('/master-data/global-search/filters');
    // return response;

    await new Promise((resolve) => setTimeout(resolve, 200));
    return mockFilterOptions;
  } catch (error) {
    console.error("Error fetching search filter options:", error);
    throw error;
  }
};
